// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppSplatRouteImport } from './routes/_app/$'
import { Route as AppAboutRouteImport } from './routes/_app/about'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppAuthRouteImport } from './routes/_app/auth'
import { Route as AppCareersRouteImport } from './routes/_app/careers'
import { Route as AppEprRouteImport } from './routes/_app/epr'
import { Route as AppHowItWorksRouteImport } from './routes/_app/how-it-works'
import { Route as AppPickupRouteImport } from './routes/_app/pickup'
import { Route as AppPrivacyRouteImport } from './routes/_app/privacy'
import { Route as AppProfileRouteImport } from './routes/_app/profile'
import { Route as AppResetPasswordRouteImport } from './routes/_app/reset-password'
import { Route as AppSelectPlanRouteImport } from './routes/_app/select-plan'
import { Route as AppSellerRouteImport } from './routes/_app/seller'
import { Route as AppTermsRouteImport } from './routes/_app/terms'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin/index'
import { Route as AppAdminAnalyticsRouteImport } from './routes/_app/admin/analytics'
import { Route as AppAdminDisputesRouteImport } from './routes/_app/admin/disputes'
import { Route as AppAdminEnquiriesRouteImport } from './routes/_app/admin/enquiries'
import { Route as AppAdminInspectorRouteImport } from './routes/_app/admin/inspector'
import { Route as AppAdminIntentsRouteImport } from './routes/_app/admin/intents'
import { Route as AppAdminKycRouteImport } from './routes/_app/admin/kyc'
import { Route as AppAdminListingsRouteImport } from './routes/_app/admin/listings'
import { Route as AppAdminOverviewRouteImport } from './routes/_app/admin/overview'
import { Route as AppAdminPickupsRouteImport } from './routes/_app/admin/pickups'
import { Route as AppAdminRatesRouteImport } from './routes/_app/admin/rates'
import { Route as AppAdminTradesRouteImport } from './routes/_app/admin/trades'
import { Route as AppAdminUsersRouteImport } from './routes/_app/admin/users'
import { Route as AppBlogIndexRouteImport } from './routes/_app/blog/index'
import { Route as AppBlogSlugRouteImport } from './routes/_app/blog/$slug'
import { Route as AppBuyerIndexRouteImport } from './routes/_app/buyer/index'
import { Route as AppBuyerInvoicesRouteImport } from './routes/_app/buyer/invoices'
import { Route as AppBuyerRequirementsRouteImport } from './routes/_app/buyer/requirements'
import { Route as AppComingSoonSlugRouteImport } from './routes/_app/coming-soon.$slug'
import { Route as AppDriverTokenRouteImport } from './routes/_app/driver.$token'
import { Route as AppInsightsIndexRouteImport } from './routes/_app/insights/index'
import { Route as AppInsightsArticleSlugRouteImport } from './routes/_app/insights/$articleSlug'
import { Route as AppLocationsIndexRouteImport } from './routes/_app/locations/index'
import { Route as AppLocationsCitySlugRouteImport } from './routes/_app/locations/$citySlug'
import { Route as AppRatesIndexRouteImport } from './routes/_app/rates/index'
import { Route as AppRatesClusterRouteImport } from './routes/_app/rates/$cluster'
import { Route as AppSellerRequirementsRouteImport } from './routes/_app/seller_.requirements'
import { Route as AppDotlovableOauthConsentRouteImport } from './routes/_app/[.]lovable.oauth.consent'
import { Route as AppBuyerOrdersIdRouteImport } from './routes/_app/buyer/orders.$id'
import { Route as AppRatesMaterialSlugCitySlugRouteImport } from './routes/_app/rates/$materialSlug.$citySlug'

const AppRoute = AppRouteImport.update({
            id: '/_app',getParentRoute: () => rootRouteImport
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRoute
          })
const AppSplatRoute = AppSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => AppRoute
          })
const AppAboutRoute = AppAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => AppRoute
          })
const AppAdminRoute = AppAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AppRoute
          })
const AppAuthRoute = AppAuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => AppRoute
          })
const AppCareersRoute = AppCareersRouteImport.update({
            id: '/careers',path: '/careers',getParentRoute: () => AppRoute
          })
const AppEprRoute = AppEprRouteImport.update({
            id: '/epr',path: '/epr',getParentRoute: () => AppRoute
          })
const AppHowItWorksRoute = AppHowItWorksRouteImport.update({
            id: '/how-it-works',path: '/how-it-works',getParentRoute: () => AppRoute
          })
const AppPickupRoute = AppPickupRouteImport.update({
            id: '/pickup',path: '/pickup',getParentRoute: () => AppRoute
          })
const AppPrivacyRoute = AppPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => AppRoute
          })
const AppProfileRoute = AppProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => AppRoute
          })
const AppResetPasswordRoute = AppResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => AppRoute
          })
const AppSelectPlanRoute = AppSelectPlanRouteImport.update({
            id: '/select-plan',path: '/select-plan',getParentRoute: () => AppRoute
          })
const AppSellerRoute = AppSellerRouteImport.update({
            id: '/seller',path: '/seller',getParentRoute: () => AppRoute
          })
const AppTermsRoute = AppTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => AppRoute
          })
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppAdminRoute
          })
const AppAdminAnalyticsRoute = AppAdminAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AppAdminRoute
          })
const AppAdminDisputesRoute = AppAdminDisputesRouteImport.update({
            id: '/disputes',path: '/disputes',getParentRoute: () => AppAdminRoute
          })
const AppAdminEnquiriesRoute = AppAdminEnquiriesRouteImport.update({
            id: '/enquiries',path: '/enquiries',getParentRoute: () => AppAdminRoute
          })
const AppAdminInspectorRoute = AppAdminInspectorRouteImport.update({
            id: '/inspector',path: '/inspector',getParentRoute: () => AppAdminRoute
          })
const AppAdminIntentsRoute = AppAdminIntentsRouteImport.update({
            id: '/intents',path: '/intents',getParentRoute: () => AppAdminRoute
          })
const AppAdminKycRoute = AppAdminKycRouteImport.update({
            id: '/kyc',path: '/kyc',getParentRoute: () => AppAdminRoute
          })
const AppAdminListingsRoute = AppAdminListingsRouteImport.update({
            id: '/listings',path: '/listings',getParentRoute: () => AppAdminRoute
          })
const AppAdminOverviewRoute = AppAdminOverviewRouteImport.update({
            id: '/overview',path: '/overview',getParentRoute: () => AppAdminRoute
          })
const AppAdminPickupsRoute = AppAdminPickupsRouteImport.update({
            id: '/pickups',path: '/pickups',getParentRoute: () => AppAdminRoute
          })
const AppAdminRatesRoute = AppAdminRatesRouteImport.update({
            id: '/rates',path: '/rates',getParentRoute: () => AppAdminRoute
          })
const AppAdminTradesRoute = AppAdminTradesRouteImport.update({
            id: '/trades',path: '/trades',getParentRoute: () => AppAdminRoute
          })
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AppAdminRoute
          })
const AppBlogIndexRoute = AppBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => AppRoute
          })
const AppBlogSlugRoute = AppBlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => AppRoute
          })
const AppBuyerIndexRoute = AppBuyerIndexRouteImport.update({
            id: '/buyer/',path: '/buyer/',getParentRoute: () => AppRoute
          })
const AppBuyerInvoicesRoute = AppBuyerInvoicesRouteImport.update({
            id: '/buyer/invoices',path: '/buyer/invoices',getParentRoute: () => AppRoute
          })
const AppBuyerRequirementsRoute = AppBuyerRequirementsRouteImport.update({
            id: '/buyer/requirements',path: '/buyer/requirements',getParentRoute: () => AppRoute
          })
const AppComingSoonSlugRoute = AppComingSoonSlugRouteImport.update({
            id: '/coming-soon/$slug',path: '/coming-soon/$slug',getParentRoute: () => AppRoute
          })
const AppDriverTokenRoute = AppDriverTokenRouteImport.update({
            id: '/driver/$token',path: '/driver/$token',getParentRoute: () => AppRoute
          })
const AppInsightsIndexRoute = AppInsightsIndexRouteImport.update({
            id: '/insights/',path: '/insights/',getParentRoute: () => AppRoute
          })
const AppInsightsArticleSlugRoute = AppInsightsArticleSlugRouteImport.update({
            id: '/insights/$articleSlug',path: '/insights/$articleSlug',getParentRoute: () => AppRoute
          })
const AppLocationsIndexRoute = AppLocationsIndexRouteImport.update({
            id: '/locations/',path: '/locations/',getParentRoute: () => AppRoute
          })
const AppLocationsCitySlugRoute = AppLocationsCitySlugRouteImport.update({
            id: '/locations/$citySlug',path: '/locations/$citySlug',getParentRoute: () => AppRoute
          })
const AppRatesIndexRoute = AppRatesIndexRouteImport.update({
            id: '/rates/',path: '/rates/',getParentRoute: () => AppRoute
          })
const AppRatesClusterRoute = AppRatesClusterRouteImport.update({
            id: '/rates/$cluster',path: '/rates/$cluster',getParentRoute: () => AppRoute
          })
const AppSellerRequirementsRoute = AppSellerRequirementsRouteImport.update({
            id: '/seller_/requirements',path: '/seller/requirements',getParentRoute: () => AppRoute
          })
const AppDotlovableOauthConsentRoute = AppDotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => AppRoute
          })
const AppBuyerOrdersIdRoute = AppBuyerOrdersIdRouteImport.update({
            id: '/buyer/orders/$id',path: '/buyer/orders/$id',getParentRoute: () => AppRoute
          })
const AppRatesMaterialSlugCitySlugRoute = AppRatesMaterialSlugCitySlugRouteImport.update({
            id: '/rates/$materialSlug/$citySlug',path: '/rates/$materialSlug/$citySlug',getParentRoute: () => AppRoute
          })





const AppAdminRouteChildren = {
  AppAdminAnalyticsRoute: AppAdminAnalyticsRoute,AppAdminDisputesRoute: AppAdminDisputesRoute,AppAdminEnquiriesRoute: AppAdminEnquiriesRoute,AppAdminInspectorRoute: AppAdminInspectorRoute,AppAdminIntentsRoute: AppAdminIntentsRoute,AppAdminKycRoute: AppAdminKycRoute,AppAdminListingsRoute: AppAdminListingsRoute,AppAdminOverviewRoute: AppAdminOverviewRoute,AppAdminPickupsRoute: AppAdminPickupsRoute,AppAdminRatesRoute: AppAdminRatesRoute,AppAdminTradesRoute: AppAdminTradesRoute,AppAdminUsersRoute: AppAdminUsersRoute,AppAdminIndexRoute: AppAdminIndexRoute
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(AppAdminRouteChildren)



const AppRouteChildren = {
  AppSplatRoute: AppSplatRoute,AppAboutRoute: AppAboutRoute,AppAdminRoute: AppAdminRouteWithChildren,AppAuthRoute: AppAuthRoute,AppCareersRoute: AppCareersRoute,AppEprRoute: AppEprRoute,AppHowItWorksRoute: AppHowItWorksRoute,AppPickupRoute: AppPickupRoute,AppPrivacyRoute: AppPrivacyRoute,AppProfileRoute: AppProfileRoute,AppResetPasswordRoute: AppResetPasswordRoute,AppSelectPlanRoute: AppSelectPlanRoute,AppSellerRoute: AppSellerRoute,AppTermsRoute: AppTermsRoute,AppIndexRoute: AppIndexRoute,AppBlogSlugRoute: AppBlogSlugRoute,AppBuyerInvoicesRoute: AppBuyerInvoicesRoute,AppBuyerRequirementsRoute: AppBuyerRequirementsRoute,AppComingSoonSlugRoute: AppComingSoonSlugRoute,AppDriverTokenRoute: AppDriverTokenRoute,AppInsightsArticleSlugRoute: AppInsightsArticleSlugRoute,AppLocationsCitySlugRoute: AppLocationsCitySlugRoute,AppRatesClusterRoute: AppRatesClusterRoute,AppSellerRequirementsRoute: AppSellerRequirementsRoute,AppBlogIndexRoute: AppBlogIndexRoute,AppBuyerIndexRoute: AppBuyerIndexRoute,AppInsightsIndexRoute: AppInsightsIndexRoute,AppLocationsIndexRoute: AppLocationsIndexRoute,AppRatesIndexRoute: AppRatesIndexRoute,AppDotlovableOauthConsentRoute: AppDotlovableOauthConsentRoute,AppBuyerOrdersIdRoute: AppBuyerOrdersIdRoute,AppRatesMaterialSlugCitySlugRoute: AppRatesMaterialSlugCitySlugRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren = {
  AppRoute: AppRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)